import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-video-list',
  templateUrl: 'video-list.html',
})
export class VideoListPage {

  videos:Array<any>;
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, private inBroser:InAppBrowser) {
    this.videos = [];
  }
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad VideoListPage');
    this.videos = [];
    this.getData();
  }


  public getData(){   
    this.http.get('https://www.googleapis.com/youtube/v3/search?key=AIzaSyA0JUgfbPbgzEsFD-SNM_ywbnUgH_L7j5A&channelId=UCuzPdCZAaE2_7RBN48E2P3A&maxResults=5&order=date&part=id,snippet&q=&type=video')
      .subscribe(
        (sucesso) => {
          this.carregarLista(sucesso);               
        },
        error => {
          // this.loading.dismiss();

        }
    ) ;
  }
  

  carregarLista(data){
    let items = data.items;
    for(var i in items) {       
      let item = items[i];
      this.adicionarVideo(item);
    }
  }
  
  adicionarVideo(item){
    let video = item.snippet
    console.log(video);
    this.videos.push({
      id : item.id.videoId,
      nome : video.title,
      descricao : video.description,
      imagem : video.thumbnails.high.url,
      url : 'https://www.youtube.com/watch?v='+item.id.videoId
    });
  }

  abrirVideo(video){
    console.log(video);
    this.inBroser.create(video.url, "_system");
  }
}



// WEBPACK FOOTER //
// ./src/pages/video-list/video-list.ts